import { createContext, useCallback, useContext, useState } from "react";
import LeadModal from "@/components/landing/LeadModal";

const LeadModalContext = createContext({
    open: (_intent, _label) => {},
});

export function LeadModalProvider({ children }) {
    const [state, setState] = useState({ open: false, intent: "contact", label: "Book Demo" });

    const open = useCallback((intent = "contact", label = "Book Demo") => {
        setState({ open: true, intent, label });
    }, []);

    const close = useCallback(() => setState((s) => ({ ...s, open: false })), []);

    return (
        <LeadModalContext.Provider value={{ open }}>
            {children}
            <LeadModal
                open={state.open}
                onOpenChange={(v) => (v ? null : close())}
                intent={state.intent}
                label={state.label}
            />
        </LeadModalContext.Provider>
    );
}

export const useLeadModal = () => useContext(LeadModalContext);
